import React from 'react';
import { useHistory } from 'react-router-dom';

import { RequestResetPasswordEmail } from 'src/components/user-flow/forgot-password';

export default function ForgotPasswordRoute() {
  const history = useHistory();

  function handleRedirectToLogin() {
    history.push('/login');
  }

  return <RequestResetPasswordEmail onSuccess={handleRedirectToLogin} onClose={handleRedirectToLogin} />;
}
